import AreaChart from '../../../../../components/Charts/AreaChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function EarningsAndExpenses ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const earningsAndExpenses = [
    ['Mês', 'Rendimentos', 'Despesas com salões'],
    ...Object.entries (data).map (([month, values]) => [
      month,
      Number (values.earnings) || 0,
      Number (values.expenses) || 0
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Receitas e despesas</SubTitle>
      <AreaChart
        data={earningsAndExpenses}
        legendPosition='top'
        options={{
          height: 350,
          colors: ['#44CF6C', '#FF3939'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Membros',
            minValue: 0,
            titleTextStyle: { bold: true }
          }
        }}
      />
    </InfoContainer>
  )
}
